import { IUser, TUserTag } from '@src/models/auth';

/** Строгая проверка ролей */
export const withTags = ({ tags, user }: { tags?: TUserTag | TUserTag[]; user?: IUser }) => {
  if (!user) return false;

  if (!tags) return true;

  if (Array.isArray(tags)) {
    if (tags.length === 0) return false;

    return tags.some((r) => user.tags.includes(r) || false);
  }

  return user.tags.includes(tags) || false;
};
